import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class DialogConfirmacionService {

	confirmar(): Observable<boolean> {
		const confirmation = window.confirm('Esta seguro de salir del proceso actual?');
		return of(confirmation);
	}
}
